// Reading the cabin api's PAMM responses. Their rows are the settlement tables' columns;
// camelCase names are accepted too.

const camelCase = key => key.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase())

export const field = (row, key) => (row ? (row[key] ?? row[camelCase(key)]) : undefined)

// A list from the cabin envelope: `results`, or its `data` when paged.
export const listOf = res => {
  const results = res?.data?.results
  if (Array.isArray(results)) return results
  return Array.isArray(results?.data) ? results.data : []
}

// One record from the cabin envelope, whether sent as an object, inside `data` or as a one-row list.
export const recordOf = res => {
  let record = res?.data?.results
  if (record && !Array.isArray(record) && record.data && typeof record.data === 'object') record = record.data
  if (Array.isArray(record)) [record] = record
  return record && typeof record === 'object' ? record : null
}

// DATETIME columns hold UTC without a zone; read them as UTC.
export const toDate = value => {
  if (!value) return null
  const text = String(value)
  const naive = /^\d{4}-\d{2}-\d{2}([ T]\d{2}:\d{2}(:\d{2}(\.\d+)?)?)?$/.test(text)
  const date = new Date(naive ? `${text.replace(' ', 'T')}${text.length === 10 ? 'T00:00:00' : ''}Z` : text)
  return Number.isNaN(date.getTime()) ? null : date
}

export const toNumber = value => (value === null || value === undefined || value === '' ? null : Number(value))
